import { useState, useEffect } from 'react'
import theme from '../../config/styles/theme'
import { PROVIDERS_TYPE } from '../../config/settings/constants'

/**
 * The Providers Chart's custom hook.
 */
const useProvidersChart = data => {
  const [serie, setSerie] = useState([])
  const sortingArr = ['Micro', 'Pequeña', 'Mediana', 'Grande', 'NoClasificado']
  const colors = [
    theme.palette.charts.ruby,
    theme.palette.charts.grape,
    theme.palette.charts.purpleHeart,
    theme.palette.charts.dodgerBlue,
    theme.palette.charts.teal
  ]

  useEffect(() => {
    const maxAmount = data.reduce(
      (a, b) => (a.montoBrutoCLPAnualTP > b.montoBrutoCLPAnualTP ? a : b),
      []
    ).montoBrutoCLPAnualTP
    const maxOC = data.reduce((a, b) => (a.nroOCAnualTP > b.nroOCAnualTP ? a : b), []).nroOCAnualTP
    data.sort(function (a, b) {
      return sortingArr.indexOf(a.tamanoProveedor) - sortingArr.indexOf(b.tamanoProveedor)
    })

    const newArray = data.map((item, index) => ({
      color: colors[index],
      percentage: item.percentage,
      percentageAmount: Math.round((item.montoBrutoCLPAnualTP * 100) / maxAmount),
      percentageOC: Math.round((item.nroOCAnualTP * 100) / maxOC),
      ProvidersCat:
        PROVIDERS_TYPE.find(provider => provider.name === item.tamanoProveedor)?.value || item.tamanoProveedor,
      totalAmount: item.montoBrutoCLPAnualTP,
      totalOC: item.nroOCAnualTP,
      year: item.year
    }))

    setSerie(newArray)
  }, [data])

  return { serie }
}

export default useProvidersChart
